import { observer } from 'mobx-react-lite'
import * as React from 'react'
import { useStore } from 'store/context'
import { CareermindsLogo } from '../careerminds-logo'

export const BootstrapCurtain: React.FC = observer(() => {
  // Defensively handle case where store might not be initialized yet
  let bootstrapping = true
  try {
    const store = useStore()
    bootstrapping = store?.bootstrapping ?? true
  } catch (error) {
    // If store is not available, assume we're still bootstrapping
    bootstrapping = true
  }

  if (!bootstrapping) return null

  return (
    <div className="fixed inset-0 bg-white z-tooltip flex items-center justify-center">
      <div className="animate-fade-in animation-delay-1 flex flex-col gap-4">
        <CareermindsLogo />
        Loading your workspace
      </div>
    </div>
  )
})
